import type { Hotel, OfferAndPackage } from '~~/domains/graphql';

export function useHotelOffersAndPackages(
  hotel: Ref<Hotel | null | undefined>,
): ComputedRef<OfferAndPackage[]> {
  return computed<OfferAndPackage[]>(() => {
    if (!Array.isArray(hotel.value?.offersAndPackages)) return [];

    return hotel.value?.offersAndPackages as OfferAndPackage[];
  });
}
